export default __webpack_public_path__ + "static/media/cp_geo_io.21130dd4.svg";